import React from 'react'
import { authRoles } from '../../auth/authRoles'
import {mongoDBChartsBaseUrl, mongoDBChartsDashboardUrl} from 'config'

const dashboardRoutes = [
    {
        path: '/dashboard',
        component: React.lazy(() => import('./home/HomePage')),
        exact: true,
        // auth: authRoles.admin,
    },
    {
        path: '/contact-us',
        component: React.lazy(() => import('./ContactUsPage')),
    }
]

if (mongoDBChartsBaseUrl && mongoDBChartsDashboardUrl) {
  dashboardRoutes.push({
    path: '/dashboard/mongodb',
    component: React.lazy(() => import('./mongodb/MongodbChartsPage')),
    auth: authRoles.admin,
  })
}

export default dashboardRoutes
